import { ArrowDownRegular, ArrowUpRegular } from '@fluentui/react-icons';
import styled, { css } from 'styled-components';

export const RadioContainer = styled.div`
  display: grid;
  grid-template-columns: max-content max-content 1fr;
  grid-template-rows: auto;
  grid-template-areas: 'radio icon label';
  align-items: center;
  gap: 8px;
  cursor: pointer;
  & > input[type='radio'] {
    accent-color: ${(props) => props.theme.serviceDeskRadioButtonColor};
    width: 16px;
    height: 16px;
  }
`;
export const Label = styled.label`
  grid-area: label;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  cursor: pointer;
  color: ${(props) => props.theme.serviceDeskTextColorPrimary};
`;
export const Input = styled.input`
  grid-area: radio;
  cursor: pointer;
`;

export const Icon = css`
  grid-area: icon;
  width: 14px;
  color: ${(props) => props.theme.serviceDeskTextColorPrimary};
`;

export const SortDownIcon = styled(ArrowDownRegular)`
  ${Icon}
`;

export const SortUpIcon = styled(ArrowUpRegular)`
  ${Icon}
`;
